import { BrandConfig } from './brand-config';

/** KfzDoku – the brand of the German app. */
export const BRAND_KFZDOKU: BrandConfig = {
  id: 'kfzdoku',
  brandName: 'KfzDoku',
  webBaseUrl: 'https://kfzdoku.de',
  cookieDomain: '.kfzdoku.de',
  supportEmail: 'info@kfzdoku.de',
  noReplyEmail: 'noreply@kfzdoku.de',
  savedPasswordDomain: 'kfzdoku.de',
  appStoreUrl: 'https://apps.apple.com/de/app/kfzdoku/id6474508304',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=de.kfzdoku',
  logoPath: 'assets/images/kfzbook-logo-medium.jpg',
  smallLogoPath: 'assets/images/kfzbook-logo-mini.png',
  pdfLogoPath: 'assets/kfzbook-logo-medium.jpg',
  statusBarColor: '#2196F3',
  usualMarketId: 'de',
};